// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YY0dF","title":"styles_title__2mvRm"};